import React from "react";
import { Card, Button, Badge } from "react-bootstrap";
import { LogOut, User as UserIcon } from "lucide-react";
import { useAuth } from "./Home1"; 

const Logout = (props) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    // Optional: Add a confirmation if you want to prevent accidental clicks
    if (window.confirm("Are you sure you want to sign out?")) {
      logout();
    }
  };

  const displayName = user?.username || props.user || "User";

  return (
    <Card className="mb-4 border-0 shadow-sm overflow-hidden rounded-4">
      {/* Header with a cleaner primary gradient-like feel */}
      <Card.Header className="bg-primary text-white py-3 border-0">
        <h6 className="mb-0 fw-bold d-flex align-items-center">
          <UserIcon size={18} className="me-2" />
          {props.Menu || "Account Status"}
        </h6>
      </Card.Header>

      <Card.Body className="p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex flex-column">
            <small className="text-muted mb-0" style={{ fontSize: '11px' }}>
              Welcome back,
            </small>
            <span className="fw-bold text-dark text-truncate" style={{ maxWidth: '120px' }}>
              {displayName}
            </span>
          </div>

          <Button 
            variant="outline-danger" 
            size="sm" 
            className="rounded-pill px-3 d-flex align-items-center fw-bold shadow-none border-2"
            onClick={handleLogout}
            style={{ fontSize: '12px', transition: '0.3s' }}
          >
            <LogOut size={14} className="me-1" />
            Logout
          </Button>
        </div>

        {/* Added an 'Active' indicator for better visual feedback */}
        <div className="mt-2 pt-2 border-top">
           <Badge bg="success" className="bg-opacity-10 text-success rounded-pill px-2 py-1" style={{ fontSize: '10px' }}>
             ● System Online
           </Badge>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Logout;